import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PhotoIcon from '@material-ui/icons/Photo';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import Avatar from '@material-ui/core/Avatar';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

import FileUploader from 'react-firebase-file-uploader';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Geocode from "react-geocode";

import _ from "lodash";
//import axios from "axios";
import firebase from '../../Firebase';
//import AsyncStorage from '@callstack/async-storage';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
//import Script from 'react-load-script';

Geocode.setApiKey("AIzaSyDdXO5VhFnc665ynEyKfgndU_ZCeOPMybk");
const drawerWidth = 240;
const mapStyle = [
  {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
  {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
  {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{color: '#c9b2a6'}]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'geometry.stroke',
    stylers: [{color: '#dcd2be'}]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{color: '#ae9e90'}]
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{color: '#93817c'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [{color: '#a5b076'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{color: '#447530'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#f5f1e6'}]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{color: '#fdfcf8'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#f8c967'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#e9bc62'}]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry',
    stylers: [{color: '#e98d58'}]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.stroke',
    stylers: [{color: '#db8555'}]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{color: '#806b63'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'labels.text.fill',
    stylers: [{color: '#8f7d77'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'labels.text.stroke',
    stylers: [{color: '#ebe3cd'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{color: '#b9d3c2'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#92998d'}]
  }
];

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  uploadingProgress: {
    color: '#f2a811',
    zIndex: 999,
  },
  uploadingProgressTxt: {
    color: '#f2a811',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#fff',
    width: 170,
    height: 170,
    borderRadius: 0,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
    width: 400
  },
  buttonProgress: {
    color: "#fff",
  },
  legendAvatar:{
    marginLeft: -32,
  },
  legendTxt:{
    marginTop: -27,
    marginRight: -32,
  },
  color_b1730d:{
    color:"#b1730d"
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#f2a811',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class Tracker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders:[],
      orderMarkers:[],
      user: {},
      drawer: true,
      config:{},
      loading: true,
    }
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClick = this.onMapClick.bind(this);
  }

  componentWillMount(){
    /*AsyncStorage.getItem("user").then(u => {
      if(u) {
        let t = this;
        let user = JSON.parse(u);
        let orders = [];
        let orderMarkers = [];

        if(!user.roles.includes("admin") && user.roles.includes("seller"))
          this.props.navigation.navigate("Inventory");

        firebase.firestore().collection("config").onSnapshot(function(docs) {
          let config = [];
          docs.forEach(doc => {
            let c = JSON.parse(doc._document.data.toString());
            c.id = doc.id;
            config.push(c);
          });
          t.setState({config:config[0]});
        });

        firebase.firestore().collection('orders').onSnapshot(function(docs) {
          docs.forEach((doc, index) => {
            let order = JSON.parse(doc._document.data.toString());
            order.doc_id = doc.id;
            orders.push(order);

            Geocode.fromAddress(order.address).then(response => {
              const { lat, lng } = response.results[0].geometry.location;
              console.log(lat, lng);
              orderMarkers.push(
                <Marker
                  key={index}
                  options={{icon:'http://maps.google.com/mapfiles/ms/icons/red-dot.png',}}
                  position={{ lat:lat, lng:lng }}
                />
              );
            }, error => {
              console.error(error);
            });

          });
          t.setState({orders:orders, orderMarkers:orderMarkers, user:user, loading:false});
        });
      } else
        this.props.navigation.navigate('Login');
    });*/
  }

  async logout(){
    try {
      //await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleSwitch(){
    firebase.firestore().collection("config").doc(this.state.config.id).update({
      shop_status: this.state.config.shop_status == "OPEN" ? "CLOSE" : "OPEN",
    }).then(() => {
    }).catch( error => {
      console.log(error);
    });
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  onMapClick = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  }

  onSearch(value){
    const BASE_URL = "https://maps.googleapis.com/maps/api/place/textsearch/xml?query=";
    fetch(`${BASE_URL}${value}${"&key=AIzaSyDdXO5VhFnc665ynEyKfgndU_ZCeOPMybk"}`, { 
      method: 'GET',
      headers:{
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Methods":"POST, GET",
        "Access-Control-Allow-Headers": "Content-Type",
      }
    })
    .then(response => response.json())
    .then(json => console.log(json));

    /*const instance = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Methods":"POST, GET",
        "Access-Control-Allow-Headers": "Content-Type",
      }
    });
    const GOOGLE_AUTOCOMPLETE_URL = "https://maps.googleapis.com/maps/api/place/queryautocomplete/json";
    const GOOGLE_API_KEY = "AIzaSyDdXO5VhFnc665ynEyKfgndU_ZCeOPMybk";
    const url = `${GOOGLE_AUTOCOMPLETE_URL}?components=country:au&types=address&input=${value}&key=${GOOGLE_API_KEY}`;
    instance.get(url).then(response => {
      console.log(response);
    });*/
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  render() {
    const { classes } = this.props;
    let config = this.state.config;
    let orders = this.state.orders
    let orderMarkers = this.state.orderMarkers;

    const MapWithAMarker = withScriptjs(withGoogleMap(props =>
      <GoogleMap
        defaultZoom={15}
        defaultCenter={{ lat: 13.1464, lng: 123.7526 }}
        defaultOptions={{ styles:mapStyle }}
      >
        <Marker
          options={{icon:'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',}}
          position={{ lat: 13.1464, lng: 123.7526 }}
        />
        { orderMarkers }
      </GoogleMap>
    ));

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Tracker
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="images/easysuki-toolbar.png" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          { !_.isEmpty(this.state.user) &&
            <div>
              <ListItem className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Users")}>
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Users" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Inventory")}>
                <ListItemIcon>
                  <StoreIcon />
                </ListItemIcon>
                <ListItemText primary="Inventory" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Config")}>
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Config" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Orders")}>
                <ListItemIcon>
                  <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primary="Orders" />
              </ListItem>
              <ListItem selected className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Tracker")}>
                <ListItemIcon>
                  <PersonPinIcon />
                </ListItemIcon>
                <ListItemText primary="Tracker" />
              </ListItem>
              <ListItem className={ !(!this.state.user.roles.includes("admin") && this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Wallet")}>
                <ListItemIcon>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary="Wallet" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("ProductRequests")}>
                <ListItemIcon>
                  <SwapHorizIcon />
                </ListItemIcon>
                <ListItemText primary="Product Requests" />
              </ListItem>
            </div>
          }
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.tableContainer}>
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
                <Grid container spacing={24}>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Paper>
                      <FormControl fullWidth className={classes.margin}>
                        <center>
                          <GooglePlacesAutocomplete
                            placeholder="Search"
                            onSelect={console.log}
                          />
                        </center>
                      </FormControl>
                    </Paper>
                    <br/>
                    <Paper>
                      <Grid container spacing={24}>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <center>
                            <Avatar className={classes.legendAvatar} src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"/>
                            <p className={classes.legendTxt}>Seller</p>
                          </center>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <center>
                            <Avatar className={classes.legendAvatar} src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"/>
                            <p className={classes.legendTxt}>Buyer</p>
                          </center>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <center>
                            <Avatar className={classes.legendAvatar} src="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"/>
                            <p className={classes.legendTxt}>Rider</p>
                          </center>
                        </Grid>
                      </Grid>
                    </Paper>
                    <br/>
                    <Grid key={2} container spacing={24}>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Paper>
                          <center>
                            {"Orders"}
                            <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                              {"0"}
                            </Typography>
                          </center>
                        </Paper>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Paper>
                          <center>
                            {"Riders"}
                            <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                              {"0"}
                            </Typography>
                          </center>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={8} sm={8} md={8} lg={8}>
                    <MapWithAMarker
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDdXO5VhFnc665ynEyKfgndU_ZCeOPMybk&libraries=geometry,drawing,places"
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `500px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                    />
                  </Grid>
                </Grid>
            }
          </div>
        </main>
      </div>
    );
  }
}

Tracker.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Tracker);